import { render, staticRenderFns } from "./user-bet.vue?vue&type=template&id=a51e62cc&scoped=true&"
import script from "./user-bet.vue?vue&type=script&lang=js&"
export * from "./user-bet.vue?vue&type=script&lang=js&"
import style0 from "./user-bet.vue?vue&type=style&index=0&id=a51e62cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51e62cc",
  null
  
)

export default component.exports